import React, { useState, useEffect } from 'react';
import config from '../../config';
import './webdev.css';

const WebDev = () => {

	const [webData, setWebData] = useState([]);

	useEffect(() => {
	    const fetchWebData = async () => {
	      try {
	        const response = await fetch(`${config.apiUrl}/web`);
	        const data = await response.json();
	        setWebData(data);
	      } catch (error) {
	        console.error('Error fetching WebDev', error);
	      }
	    };
	    fetchWebData();
	  }, []);

	return (
		<div style={{ padding: '0%, 8%', maxWidth: '800px' }}>
            {webData.length ? (
            	webData[0].content.map((block, index) => {
            	switch(block.type) {
                	case 'paragraph':
                		return <p key={index}>{block.text}</p>;
                	case 'heading':
                		return <h2 key={index}>{block.text}</h2>;
                	case 'subheading':
                		return <h3 key={index}>{block.text}</h3>;
                	case 'subsubheading':
                		return <h4 key={index}>{block.text}</h4>;
                	case 'unorderedlist':
                		return (
                			<ul key={index}>
                				{block.items.map((item, itemIndex) => (
                					<li key={itemIndex}>{item}</li>
                				))}
                			</ul>);
                	case 'link':
    				// Identify if there are multiple consecutive links
		              // const previousBlock = webData[0].content[index - 1];
		              const nextBlock = webData[0].content[index + 1];
		              // const isPreviousLink = previousBlock && previousBlock.type === 'link';
		              const isNextLink = nextBlock && nextBlock.type === 'link';
		              
		              // Only add the separator if both previous and next blocks are links
		              return (
		                <span key={index} style={{ display: 'inline' }}>
		                  <a className='link' href={block.url} style={{ marginRight: '5px' }}>{block.text}</a>
		                  {isNextLink && ' | '}
		                </span>
		              );
                	case 'orderedlist':
                		return (
                			<ol key={index}>
                				{block.items.map((item, itemIndex) => (
                					<li key={itemIndex}>{item}</li>
                				))}
                			</ol>);
                	case 'image':
                		return <img key={index} src={block.url} alt={block.alt} />;
                    default:
                        return <p key={index}>{block.text}</p>;
                }})
            	) : (
            		<h2>Loading...</h2>)
            }
		</div>
	)
}

export default WebDev;